/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from '@wapps/gatsby-plugin-i18next'

import styled, { layout, color, typography, space } from '@style'

const StyledLink = styled(GatsbyLink)`
  /* stylelint-disable */
  ${layout}
  ${color}
  ${typography}
  ${space}
`

const Link = ({ children, ...props }) => (
  <StyledLink {...props}>{children}</StyledLink>
)

Link.propTypes = {
  /** Page name to navigate to */
  to: PropTypes.string.isRequired,
  /** Function to run on click */
  onClick: PropTypes.func,
  /** children */
  children: PropTypes.node.isRequired,
  /** Relevant for styled-components */
  className: PropTypes.string,
}

Link.defaultProps = {
  className: null,
  onClick: () => {},
}

export default Link
